import { useState } from "react";
import SavingsBreakdown from "./overall/SavingsBreakdown";
import ROSMACalculation from "./overall/ROSMACalculation";
import DecisionOptimization from "./overall/DecisionOptimization";
import "./OverallAssessment.css";

const OverallAssessment = ({ data }) => {
    const [savingsSummary, setSavingsSummary] = useState(null);

    return (
        <div className="space-y-6">
            <SavingsBreakdown data={data} onSavingsUpdate={setSavingsSummary}/>
            <ROSMACalculation data={data} savingsSummary={savingsSummary ?? undefined}/>
            <DecisionOptimization data={data}/>
        </div>
    );
};

export default OverallAssessment;
